/* eslint-disable no-console */
import React from 'react';
import {
	Container,
	Button,
	Row,
	Col,
	Card,
	CardBody,
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import AddAPhoto from '@mui/icons-material/AddAPhoto';

import logo from '~/assets/img/faces/joe-gardner-2.jpg';
import { SubHeader } from '~/components/SubHeader';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

import {
	ContentPerfil,
	ContentLeft,
	ContentRight,
	FotoPerfil,
	FormDiv,
	ButtonStyle,
	ButtonDiv,
} from './styles';

function PerfilEdit() {
	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Editar perfil',
						link: '/client/perfil-edit',
					},
				]}
			/>

			<Row className="my-5 border-bottom pb-2">
				<Col md="9" className="d-flex aling-items-center">
					<Text size="large">Editar Perfil</Text>
				</Col>
				<Col md="3" className="d-flex justify-content-end">
					<Link
						className="notranslate"
						to="/client/dashboard"
						style={{ color: `${color.blue}` }}>
						Voltar para home
					</Link>
				</Col>
			</Row>
			<Card>
				<CardBody>
					<ContentPerfil>
						<ContentLeft>
							<FotoPerfil src={logo} />
							<ButtonDiv>
								<ButtonStyle onClick={() => console.log('Oi')}>
									<AddAPhoto />
								</ButtonStyle>
							</ButtonDiv>
						</ContentLeft>

						<ContentRight>
							<FormDiv>
								<FormGroup>
									<Label>Nome</Label>
									<Input
										id=""
										type="name"
										placeholder="Fulano"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
								<FormGroup>
									<Label>Sobrenome</Label>
									<Input
										id=""
										type="surname"
										placeholder="de Tal"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<FormDiv>
								<FormGroup>
									<Label>CPF</Label>
									<Input
										id=""
										type="name"
										placeholder="999.999.999-99"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
								<FormGroup>
									<Label>Data de Nascimento</Label>
									<Input
										id=""
										type="surname"
										placeholder="99/99/9999"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<FormDiv>
								<FormGroup>
									<Label>E-mail</Label>
									<Input
										id=""
										type="surname"
										placeholder="fulano.detal@testando.com"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<FormDiv>
								<FormGroup>
									<Label>Telefone</Label>
									<Input
										id=""
										type="name"
										placeholder="(99)9999-9999"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
								<FormGroup>
									<Label>CEP</Label>
									<Input
										id=""
										type="surname"
										placeholder="99999-999"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<FormDiv>
								<FormGroup>
									<Label>Rua / Avenida</Label>
									<Input
										id=""
										type="surname"
										placeholder="Rua Jose de Anchieta"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<FormDiv>
								<FormGroup>
									<Label>Número</Label>
									<Input
										id=""
										type="name"
										placeholder="552"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
								<FormGroup>
									<Label>Complemento</Label>
									<Input
										id=""
										type="surname"
										placeholder="Ap 102"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<FormDiv>
								<FormGroup>
									<Label>Cidade</Label>
									<Input
										id=""
										type="name"
										placeholder="São Paulo"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
								<FormGroup>
									<Label>Estado</Label>
									<Input
										id=""
										type="surname"
										placeholder="SP"
										onChange={(elemento) =>
											console.log(elemento)
										}
									/>
								</FormGroup>
							</FormDiv>

							<div className="d-flex justify-content-end mb-4">
								<Button
									color="primary"
									onClick={() => console.log('Oi')}>
									Salvar
								</Button>
							</div>
						</ContentRight>
					</ContentPerfil>
				</CardBody>
			</Card>
		</Container>
	);
}

export default PerfilEdit;
